import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import TicketList from "../pages/ticket/TicketList";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CreateTicket from "../pages/ticket/CreateTicket";
//@ts-ignore
import { AccessControl,PermissionRequired} from "@careinfo/merchant-permission-service";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path={"/"} element={<TicketList />} />
          <Route path={"/create"} element={
            <AccessControl children={
              <CreateTicket />
            }
            allowedPermissions={["can_perform_ticket_action"]}
            renderNoAccess={<PermissionRequired/>}
           />
            } 
            
            />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
